import React from "react"
import {
  Container,
  ListAppLogin,
  Header,
  NavLink,
  LogoName
} from "./Login.styles"
import logo from "../../assets/image/logo_128 1.png"
import AppItem from "./AppItem"
import { Alert, List, ListItem, Snackbar } from "@mui/material"
import { useAppDispatch, useAppSelector } from "src/hooks/redux"
import { closeToast } from "src/reducer/toastAuth.reducer"
import { appLoginDatas } from "./AppLoginDatas"
import MSTeamsLogin from "./MSTeamsLogin"
import { Box } from "@mui/system"
import GoogleLoginItem from "./GoogleLogin"
import Loading from "src/components/Loading/Loading"

const Login = () => {
  const dispatch = useAppDispatch()
  const open = useAppSelector(state => state.authToast.open)
  const messages = useAppSelector(state => state.authToast.messages)
  const severity = useAppSelector(state => state.authToast.severity)
  return (
    <Box
      sx={{ backgroundColor: "#F6F6F6", height: "100vh", overflow: "hidden" }}
    >
      <Loading />
      <Header>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <img src={logo} width="48" height="48" alt="" />
          <LogoName variant="h5">Standup Alice</LogoName>
        </Box>
        <Box>
          <List
            dense={true}
            component="nav"
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <ListItem>
              <NavLink
                href="https://standupalice.com"
                rel="noreferrer"
                target="_blank"
              >
                Home
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink
                href="https://standupalice.com/features"
                rel="noreferrer"
                target="_blank"
              >
                Features
              </NavLink>
            </ListItem>
            <ListItem>
              <NavLink
                href="https://standupalice.freshdesk.com/support/solutions"
                rel="noreferrer"
                target="_blank"
              >
                Support
              </NavLink>
            </ListItem>
          </List>
        </Box>
      </Header>
      <Container>
        <ListAppLogin>
          <AppItem
            appItem={appLoginDatas[0]}
            key={0}
            learnMoreUrl={
              "https://standupalice.freshdesk.com/support/solutions/folders/35000193246"
            }
          ></AppItem>
          <GoogleLoginItem />
          <AppItem
            appItem={appLoginDatas[1]}
            key={1}
            learnMoreUrl={
              "https://standupalice.freshdesk.com/support/solutions"
            }
          ></AppItem>
          <MSTeamsLogin />
        </ListAppLogin>
        <Snackbar
          open={open}
          onClose={() => dispatch(closeToast())}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => dispatch(closeToast())}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {messages}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  )
}

export default Login
